import { useMemo } from "react";
import Card from "react-bootstrap/Card";
import { FaAddressCard, FaUserEdit } from "react-icons/fa";
import { Link } from "react-router-dom";

import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../../scripts/helperScripts";
import FieldDisplay from "../common/FieldDisplay";

const CareTeamCard = ({ teamMember, onEdit }) => {
  const hasContactInfo = useMemo(() => {
    return teamMember["con.telephone2"] ||
      teamMember["con.mobilephone"] ||
      teamMember["con.telephone1"] ||
      teamMember["con.fax"] ||
      teamMember["con.emailaddress1"] ||
      teamMember["con.emailaddress2"]
      ? true
      : false;
  }, [teamMember]);

  const classes = useMemo(() => {
    if (teamMember.ccx_expdate) {
      return "bg-warning p-1 ps-4";
    } else if (getFieldName(teamMember.ccx_membertype) === "Contact") {
      return "bg-safy2-1 p-1 ps-4";
    } else if (getFieldName(teamMember.ccx_membertype) === "Provider") {
      return "bg-safy1-1 p-1 ps-4";
    }
  }, [teamMember, hasContactInfo]);

  const title = useMemo(() => {
    let title = getFieldName(teamMember.ccx_membertype) + ": ";

    if (getFieldName(teamMember.ccx_membertype) === "Provider")
      title += `${getFieldName(teamMember.ccx_memberid)}${
        teamMember.sor_providerrole
          ? `, ${getFieldName(teamMember.sor_providerrole)}, Primary: ${
              getFieldText(teamMember.ccx_primarymember) === "1" ? "Yes" : "No"
            } `
          : ""
      }`;
    else
      title += `${getFieldName(teamMember.ccx_contact)}${
        teamMember.sor_contactrole
          ? `, ${getFieldName(teamMember.sor_contactrole)}`
          : ""
      } `;

    title += `(${getFieldDate(teamMember.ccx_effdate)} - ${
      teamMember.ccx_expdate ? getFieldDate(teamMember.ccx_expdate) : "no date"
    })`;

    return title;
  }, [teamMember, hasContactInfo]);

  return (
    <Card className="card-safy">
      <Card.Header className={classes} style={{ color: "white" }}>
        <div className="row">
          <div className="col">
            {getFieldName(teamMember.ccx_membertype) === "Contact" ? (
              <Link
                title={title}
                to={`/contact/${getFieldText(teamMember.ccx_contact).replace(
                  /[{}]/g,
                  ""
                )}`}
                state={{
                  businessUnitName: getFieldName(
                    teamMember.ccx_clientprogram
                  ).split(" - ")[0],
                }}
                className="text-white"
              >
                {title}
              </Link>
            ) : (
              title
            )}
          </div>
          <div className="col-auto d-flex align-items-center">
            {getFieldName(teamMember.ccx_membertype) === "Contact" ? (
              <>
                {teamMember["con.programs"] ? (
                  <Link
                    title="Open Client Info"
                    to={`/client/${getFieldText(teamMember.ccx_contact).replace(
                      /[{}]/g,
                      ""
                    )}`}
                    state={{
                      tab: "client",
                      clientId: getFieldText(teamMember.ccx_contact).replace(
                        /[{}]/g,
                        ""
                      ),
                    }}
                    className="text-white"
                  >
                    <FaAddressCard size="1.25rem" className="me-2" />
                  </Link>
                ) : null}
                <Link
                  title="Open Contact Info"
                  to={`/contact/${getFieldText(teamMember.ccx_contact).replace(
                    /[{}]/g,
                    ""
                  )}`}
                  state={{
                    businessUnitName: getFieldName(
                      teamMember.ccx_clientprogram
                    ).split(" - ")[0],
                  }}
                  className="text-white"
                >
                  <FaUserEdit size="1.25rem" className="me-2" />
                </Link>
              </>
            ) : null}
            <i
              title="Edit"
              className="fas fa-pen p-1"
              onClick={onEdit}
              style={{ color: "#FFFFFF" }}
            />
          </div>
        </div>
      </Card.Header>
      {hasContactInfo ||
      getFieldText(teamMember.sor_emergencycontact) === "1" ? (
        <Card.Body className="card-body-safy">
          {teamMember["con.telephone2"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Home Phone"
                  value={teamMember["con.telephone2"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.mobilephone"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Mobile Phone"
                  value={teamMember["con.mobilephone"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.telephone1"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Business Phone"
                  value={teamMember["con.telephone1"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.fax"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Fax"
                  value={teamMember["con.fax"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.emailaddress1"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Email Address 1"
                  value={teamMember["con.emailaddress1"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.emailaddress2"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Email Address 2"
                  value={teamMember["con.emailaddress2"]}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.ccx_primarycontactmethod"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Primary Contact Method"
                  value={getFieldName(
                    teamMember["con.ccx_primarycontactmethod"]
                  )}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {teamMember["con.ccx_secondarycontactmethod"] && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Secondary Contact Method"
                  value={getFieldName(
                    teamMember["con.ccx_secondarycontactmethod"]
                  )}
                ></FieldDisplay>
              </div>
            </div>
          )}
          {getFieldText(teamMember.sor_emergencycontact) === "1" && (
            <div className="row">
              <div className="col">
                <FieldDisplay
                  label="Emergency Contact"
                  value="Yes"
                ></FieldDisplay>
              </div>
            </div>
          )}
        </Card.Body>
      ) : null}
    </Card>
  );
};

export default CareTeamCard;
